// src/stone/icons/SecurityKey2X.tsx
import { jsx } from "react/jsx-runtime";
var SecurityKey2X = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M35.707 2.626a1 1 0 0 1 0 1.414l-2.626 2.627 4.293 4.293a1 1 0 0 1 0 1.414l-5.834 5.833a1 1 0 0 1-1.414 0l-4.293-4.293-5.466 5.467A10.168 10.168 0 0 1 5.308 33.016l-.007-.008a10.167 10.167 0 0 1 13.635-15.025L34.293 2.626a1 1 0 0 1 1.414 0m-4.04 5.455-4.42 4.419 3.586 3.586 4.42-4.42zm-13.34 12.027-.04-.037A8.167 8.167 0 0 0 6.736 31.615a8.167 8.167 0 1 0 11.591-11.507" })
  }
);
var SecurityKey2X_default = SecurityKey2X;

export {
  SecurityKey2X,
  SecurityKey2X_default
};
